module.exports = __webpack_public_path__ + "img/scalecontrol.c247e583.svg";